<mat-toolbar color="primary" class="headerTop" [class.devsite]="isDevsite === true" fxLayoutAlign="space-between center">
    <button mat-icon-button (click)="onToggleMenu()" *ngIf="!isLoginLayout">
        <mat-icon aria-label="Toggle menu">menu</mat-icon>
    </button>

    <h1 class="appTitle" fxHide fxShow.gt-sm>Multiple Pathways Education</h1>
    <div layout="column" layout-align="end start" fxHide fxShow.gt-md>
        <span class="mat-subhead" style="margin-top:1rem">A division of Polk County Public Schools</span>
    </div>
    <div class="devsiteTitle" *ngIf="isDevsite === true" [innerHtml]="'DEVELOPMENT SITE'"></div>
    <span fxFlex></span>

    <div *ngIf="user?.LastName !== '' && user?.LastName !== null && !isLoginLayout" fxHide fxShow.gt-md fxLayout="column" fxLayoutAlign="start end">
        <h3>Welcome, {{user?.FirstName}} {{user?.LastName}} <span *ngIf="user?.IsImpersonation">[Impersonated]</span></h3>
        <span class="mat-caption" style="padding-top: 0" *ngIf="!user?.Roles || !user?.Roles?.length || !user?.IsMultiRole">{{user?.CurrentRole | roleFilter}}</span>
        <div class="formFieldHeight" *ngIf="user?.LastName !== '' && user?.LastName !== null && !isLoginLayout" >
            <app-multi-role-selector></app-multi-role-selector>
        </div>
    </div>

    <!-- <button mat-icon-button class="darkModebtn" (click)="onToggleDarkTheme(isDarkTheme = !isDarkTheme)" *ngIf="!isLoginLayout">
        <mat-icon 
            [title]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
            [attr.aria-label]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'">
            {{ isDarkTheme ? 'light_mode' : 'dark_mode'}}
        </mat-icon>
    </button> -->

    <!-- <mat-chip-list>
    <mat-chip [matMenuTriggerFor]="menu">
      <mat-chip-avatar>
        <img class="avatar-image" src="https://www.w3schools.com/howto/img_avatar.png"/>
      </mat-chip-avatar>
      Name
    </mat-chip>
  </mat-chip-list> -->
    
    <button class="profileBtn" mat-icon-button [matMenuTriggerFor]="menu" *ngIf="!isLoginLayout">
        <mat-icon aria-hidden="false" aria-label="Account user icon">account_circle</mat-icon> 
    </button>

    <mat-menu #menu="matMenu" class="profileMenu">
        <mat-list class="wrapper">
            <mat-list-item class="user-info-grid">
                <div matListAvatar class="avatar-container">
                    <mat-icon class="avatar" aria-hidden="false" aria-label="Account user icon">account_circle</mat-icon>
                </div>
                <div matLine class="name">{{ user?.FirstName }} {{ user?.LastName }}</div>
                <div matLine class="userRole">
                    <span *ngIf="role === 'Developer'">Multiple Pathways Developer Access</span>
                    <span *ngIf="role === 'SystemAdmin'">System Administrator Access</span>
                    <span *ngIf="role === 'Clearinghouse'">Clearinghouse Team Access</span>
                    <span *ngIf="role === 'ProgramContact'">Program Contact Access</span>
                    <span *ngIf="role === 'DistrictStaff'">District Staff Access</span>
                    <span *ngIf="role === 'Principal'">School Principal Access</span>
                    <span *ngIf="role === 'AssistantPrin'">School Assistant Principal Access</span>
                    <span *ngIf="role === 'Counselor'">School Counselor Access</span>
                    <span *ngIf="role === 'SuccessCoach'">Success Coach Access</span>
                    <span *ngIf="role === 'StudentAdvisor'">Student Advisor Access</span>
                    <span *ngIf="role === 'Designee'">School Designee Access</span>
                    <span *ngIf="role === 'Reader'">Application Reader Access</span>
                </div>
                <!-- <button mat-icon-button class="menuArrow" [matMenuTriggerFor]="settingsMenu" (click)="$event.stopPropagation()" aria-label="An icon of a gear for settings menu">
                    <mat-icon>settings</mat-icon>
                </button> -->
            </mat-list-item>
        </mat-list>
        <!-- <button mat-menu-item><mat-icon>person</mat-icon>Profile</button> -->
        <!-- <button mat-menu-item><mat-icon>settings</mat-icon>Settings</button> -->
        <mat-divider></mat-divider>
        <!-- <button mat-menu-item><mat-icon>help</mat-icon>Need Help?</button> -->

        <button mat-menu-item (click)="onToggleDarkTheme(isDarkTheme = !isDarkTheme)">
            <mat-icon 
                [title]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
                [attr.aria-label]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'">
                {{ isDarkTheme ? 'light_mode' : 'dark_mode'}}
            </mat-icon>{{isDarkTheme ? 'Light Mode' : 'Dark Mode'}}
        </button>

        <button mat-menu-item *ngIf="user; else sign_in" (click)="logout()">
            <mat-icon>login</mat-icon>Logout
        </button>

        <ng-template #sign_in>
            <button mat-menu-item (click)="login()">
                <mat-icon>login</mat-icon>Sign In
            </button>
        </ng-template>
    </mat-menu>
    <!-- <mat-menu #settingsMenu="matMenu" xPosition="before">
        <button mat-menu-item (click)="logout()">
            <mat-icon>login</mat-icon>Sign Out
        </button>
    </mat-menu> -->
</mat-toolbar>
